/* assets/pl-media-grid-cap.js - PL 2026-10-20
   Desktop PDP grid cap. snippets/product-media.liquid renders the grid with
   items past the cap marked data-pl-capped (no layout shift, hidden images
   never download); snippets/pl-media-grid-cap.liquid renders the button.
   This script:
   - toggles the hidden items with the "Show more images" button, moving focus
     to the first revealed image and announcing the change;
   - re-applies the cap when a colour change swaps the visible set (Focal
     toggles .is-filtered; pl-media-groups.js inserts a new colour's items),
     returning to the capped view because it is a new set of photos;
   - opens the grid when the chosen variant's own image sits past the cap, so
     picking a colour never points at a hidden photo. */
(function () {
  'use strict';

  function init(wrap) {
    if (wrap.getAttribute('data-pl-cap-init')) return;
    wrap.setAttribute('data-pl-cap-init', '1');

    var grid = document.getElementById(wrap.getAttribute('data-grid'));
    var btn = wrap.querySelector('.pl-media-more__btn');
    var label = wrap.querySelector('.pl-media-more__label');
    if (!grid || !btn || !label) return;

    var cap = parseInt(wrap.getAttribute('data-cap'), 10) || 6;
    var live = document.getElementById(wrap.getAttribute('data-live'));
    var expanded = wrap.getAttribute('data-state') === 'open';
    var lastSet = null;
    var pendingMediaId = null;
    var raf = 0;

    function visibleItems() {
      return Array.prototype.filter.call(grid.children, function (el) {
        return el.classList.contains('product__media-item') && !el.classList.contains('is-filtered');
      });
    }

    function announce(text) {
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 50);
    }

    /* The control is the grid's last cell. pl-media-groups.js appends a new
       colour's items at the end of the grid, which would put them after the
       button; move the button back behind the last media item. */
    function keepLast() {
      var all = grid.querySelectorAll(':scope > .product__media-item');
      var lastItem = all[all.length - 1];
      if (wrap.parentNode === grid && lastItem && (wrap.compareDocumentPosition(lastItem) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        grid.insertBefore(wrap, lastItem.nextSibling);
      }
    }

    function apply() {
      raf = 0;
      keepLast();
      var items = visibleItems();
      var set = items.map(function (el) { return el.getAttribute('data-media-id'); }).join(',');

      /* A different set of photos (colour change) starts capped again. */
      if (lastSet !== null && set !== lastSet) expanded = false;
      lastSet = set;

      /* The chosen variant's image must be on screen: open the grid if it is past the cap. */
      if (pendingMediaId) {
        var idx = -1;
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === pendingMediaId) { idx = i; break; }
        }
        if (idx !== -1) {
          if (idx >= cap) expanded = true;
          pendingMediaId = null;
        }
      }

      items.forEach(function (el, i) {
        if (!expanded && i >= cap) {
          if (!el.hasAttribute('data-pl-capped')) el.setAttribute('data-pl-capped', '');
        } else if (el.hasAttribute('data-pl-capped')) {
          el.removeAttribute('data-pl-capped');
        }
      });
      Array.prototype.forEach.call(grid.children, function (el) {
        if (el.classList.contains('is-filtered') && el.hasAttribute('data-pl-capped')) el.removeAttribute('data-pl-capped');
      });

      var extra = items.length - cap;
      if (extra <= 0) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? 'Show fewer images' : 'Show more images (' + extra + ')';
    }

    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(apply);
    }

    btn.addEventListener('click', function () {
      var items = visibleItems();
      if (!expanded) {
        expanded = true;
        apply();
        var first = items[cap];
        if (first) {
          if (!first.hasAttribute('tabindex')) first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
        var shown = items.length - cap;
        announce(shown + (shown === 1 ? ' more image shown' : ' more images shown'));
      } else {
        expanded = false;
        apply();
        /* The grid just got shorter: bring the button back into view so the
           shopper is not left looking at whatever slid up underneath. */
        var r = wrap.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) wrap.scrollIntoView({ block: 'center' });
        btn.focus({ preventScroll: true });
        announce('Showing the first ' + cap + ' images');
      }
    });

    /* Colour changes: Focal toggles .is-filtered on the items; pl-media-groups.js
       inserts new ones. Only class and child changes matter - this script writes
       data-pl-capped, which the observer ignores, so it cannot loop. */
    new MutationObserver(schedule).observe(grid, {
      childList: true,
      subtree: false, /* PL 2026-10-30 perf: only direct-child class/child changes matter; subtree fired on every lazy image */
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('variant:changed', function (e) {
      var v = e && e.detail ? e.detail.variant : null;
      var media = v && v.featured_media;
      pendingMediaId = media && media.id ? String(media.id) : null;
      schedule();
    });

    apply();
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-pl-media-more]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
